import { h } from 'preact';
import { DepartmentLabel } from './DepartmentLabel.jsx';

// For which afdelingen a role applies (eigen beheer per afdeling): a box per department;
// none ticked = the whole club, as before
export default function RoleDepartmentPicker({ departments, value, onChange, disabled }) {
  const toggle = id => onChange(value.includes(id) ? value.filter(v => v !== id) : [...value, id]);
  return (
    <fieldset style="border:none;padding:0;margin:0">
      <legend style="font-size:13px;color:var(--color-text-muted);margin-bottom:6px">
        Geldt voor afdeling(en) — geen vinkje: de hele club
      </legend>
      <div style="display:flex;flex-wrap:wrap;gap:6px 14px">
        {departments.map(d => (
          <label key={d.id} style="display:inline-flex;align-items:center;gap:6px;font-size:13px;cursor:pointer">
            <input type="checkbox" checked={value.includes(d.id)} disabled={disabled} onChange={() => toggle(d.id)} />
            <DepartmentLabel department={d} />
          </label>
        ))}
      </div>
    </fieldset>
  );
}

// Behind a role on the member's page: for which departments it applies. departments
// null: not loaded (yet), so nothing rather than a wrong "geldt nergens"
export function RoleDepartmentsText({ role, departments }) {
  if (role.department_ids == null || departments == null) return null;
  const names = departments.filter(d => role.department_ids.includes(d.id)).map(d => d.name);
  return (
    <span style="font-size:12px;color:var(--color-text-muted)">
      {names.length ? `alleen ${names.join(', ')}` : 'geen afdeling meer: geldt nergens'}
    </span>
  );
}
